module.exports = __webpack_public_path__ + "img/card.5bd3968d.png";